namespace TabAurous.ProductDevelopment {
    export interface PDQuotationAdditionalChargesRow {
        TransChargesId?: number;
        TransItemId?: number;
        AdditionalChargeId?: number;
        Rate?: number;
        Amount?: number;
        Chargeable?: number;
        AdditionalChargeCode?: string;
        AdditionalChargeName?: string;
        ProductCalculateOn?: Common.AdditionalChargesProductCalcon;
        ApplicableOn?: Common.AdditionalChargesType;
        RateType?: Common.AdditionalChargesRateType;
    }

    export namespace PDQuotationAdditionalChargesRow {
        export const idProperty = 'TransChargesId';
        export const localTextPrefix = 'ProductDevelopment.PDQuotationAdditionalCharges';
        export const deletePermission = 'PD:Quotation:Delete';
        export const insertPermission = 'PD:Quotation:Add';
        export const readPermission = '*';
        export const updatePermission = 'PD:Quotation:Edit';

        export declare const enum Fields {
            TransChargesId = "TransChargesId",
            TransItemId = "TransItemId",
            AdditionalChargeId = "AdditionalChargeId",
            Rate = "Rate",
            Amount = "Amount",
            Chargeable = "Chargeable",
            AdditionalChargeCode = "AdditionalChargeCode",
            AdditionalChargeName = "AdditionalChargeName",
            ProductCalculateOn = "ProductCalculateOn",
            ApplicableOn = "ApplicableOn",
            RateType = "RateType"
        }
    }
}
